/* DONGXI cart add-ons (2026-09-23) – see snippets/dongxi-cart-upsell.liquid */
(function () {
  if (window.__dxCartUpsell) return;
  window.__dxCartUpsell = true;

  document.addEventListener('change', function (event) {
    var select = event.target.closest && event.target.closest('[data-dx-upsell-select]');
    if (!select) return;
    var card = select.closest('[data-dx-upsell-card]');
    var option = select.selectedOptions && select.selectedOptions[0];
    var price = card && card.querySelector('[data-dx-upsell-price]');
    if (price && option && option.dataset.price) price.textContent = option.dataset.price;
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-dx-upsell-add]');
    if (!button) return;
    event.preventDefault();
    if (button.getAttribute('aria-busy') === 'true') return;
    var card = button.closest('[data-dx-upsell-card]');
    var select = card && card.querySelector('[data-dx-upsell-select]');
    var error = card && card.querySelector('[data-dx-upsell-error]');
    var variantId = Number(select ? select.value : button.dataset.variantId);
    if (!variantId) return;

    var drawer = button.closest('cart-drawer');
    var body = { items: [{ id: variantId, quantity: 1 }] };
    if (drawer) {
      body.sections = 'cart-drawer,cart-icon-bubble';
      body.sections_url = window.location.pathname;
    }
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

    button.setAttribute('aria-busy', 'true');
    if (error) error.hidden = true;

    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status) throw new Error(data.description || 'add failed');
          return data;
        });
      })
      .then(function (data) {
        if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
          drawer.renderContents({ id: variantId, sections: data.sections });
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        button.removeAttribute('aria-busy');
        if (error) error.hidden = false;
      });
  });
})();
